<template>
  <div id='app' v-cloak>
    <router-view />
    <UsagePolicyPopup :showUsagePopup="showUsagePopup" @submit-policy="submitToc()" @close-policy-pop="closeTOC()"></UsagePolicyPopup>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import VueSocketio from 'vue-socket.io-extended';
import io from 'socket.io-client';
import { mapState, mapGetters } from 'vuex' 
import moment from 'moment'
import crypto from 'crypto'
import UsagePolicyPopup from '@/components/UsagePolicyPopup'

Vue.use(VueSocketio, io('wss://app-websocket.callbox.com/conversations', { 'forceNew': true }), store);

export default {
  name: 'App',
  metaInfo: {
    title: 'Call Box',
    meta: [
      { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' }
    ],
    link: [
      { rel: 'stylesheet', href: require('../assets/css/global.css') },
      { rel: 'stylesheet', href: require('../assets/css/material_icons.css') },
      { rel: 'stylesheet', href: require('../assets/css/audio_player.css') }
    ],
    script: [
      { src: require('../assets/js/sfwobject.js') }
    ]
  },
  components: { UsagePolicyPopup },
  data: function () {
    return {
      currentView: 'inbox',
      waveformsArray: [],
      showTestUsagePopup: false,
      aniTrack: '',
      aniTrackPhonecodeExclusion: -9999
    }
  },
  computed: {
    ...mapState({
      socketOn: state => state.socketOn,
      currentAccount: state => state.account.lskinid,
      selectedFilter: state => state.selectedFilter,
      selectedPhonecodeGroup: state => state.selectedPhonecodeGroup,
      user: state => state.user,
      currentConvo: state => state.conversation,
      showUsagePopup: state => state.showUsagePopup,
      showReplyPopup: state => state.showUsagePopup,
      liveButton: state => state.liveButton,
      phonecodesToGroupsMap: state => state.phonecodesToGroupsMap,
      secret: state => state.secret,
      linesToFilter: state => state.linesToFilter
    }),
    ...mapGetters([
      'lskins',
      'filteredLskins',
      'filterLines'
    ])
  },
  mounted: function () {
    this.$root.$on('campaignAniTrack', (ani) => {
      this.aniTrack = ani;
    })

    if (this.user && this.user.frn_phonecodeid) {
      this.aniTrackPhonecodeExclusion = this.user.frn_phonecodeid;
    }
  },
  watch: {
    socketOn: function (val) {
      if (val) { this.startSocket(); }
    }
  },
  methods: {
    formatNumber: function (number) {
      var cleaned = ('' + number).replace(/\D/g, '');
      var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return match[1] + '-' + match[2] + '-' + match[3];
      }
      return null;
    },
    getHash: function (request) {
      return crypto.createHmac("sha256", this.secret)
        .update(JSON.stringify(request))
        .digest("hex");
    },
    closeTOC: function () {
      this.$store.commit({
        type: 'setUsagePopup',
        showUsagePopup: false
      })
    },
    submitToc: async function () {
      this.$store.commit({
        type: 'setUsagePopup',
        showUsagePopup: false,
        showReplyPopup: true
      })
      let endpoint = `/users/${this.user.leuserid}/createUsage`;
      let res = await this.axios.post(endpoint)
      .then((response) => {
        console.log(response)
      })
    },
    startSocket: async function() {
      await this.$socket.emit('join-room', this.filteredLskins);
    },
    formatTime: function(time) {
      time = time.split(':');
      var hours = Number(time[0]);
      var minutes = Number(time[1]);
      var timeValue;

      if (hours > 0 && hours <= 12) {
        timeValue = "" + hours;
      } else if (hours > 12) {
        timeValue = "" + (hours - 12);
      } else if (hours == 0) {
        timeValue = "12";
      }
      timeValue += (minutes < 10) ? ":0" + minutes : ":" + minutes;
      timeValue += (hours >= 12) ? "pm" : "am";

      return timeValue;
    },
    loadConversationByAni: async function (url) {
      let resService = await this.axios.get(url).catch(error => console.log(error));
      return resService.data;
    },
    formatName: function (aniname, aninum) {
      let callerLabel = ''
      if (aniname) {
        if (aniname.indexOf(',') > -1) {
          callerLabel = aniname.split(',');
          var firstName = callerLabel[1];
          var lastName = callerLabel[0];
          callerLabel = firstName + ' ' + lastName;
        } else {
          callerLabel = aniname;
        }
      } else {
        callerLabel = aninum;
        var s2 = ('' + callerLabel).replace(/\D/g, '');
        var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
        callerLabel = (!m) ? null : '(' + m[1] + ') ' + m[2] + '-' + m[3];
      }
      return callerLabel;
    },
    appendDnisInformation: async function (dnisid, msg) {
      return new Promise( async (resolve, reject) => {
        try {
          const dnisObj = msg.interaction.dnis;

          switch(msg.interaction.type) {
            case 'Call':
              msg.dnisIcon = 'phone';
              msg.dnisType = msg.interaction.direction == 'inbound' ? 'IB' : 'OB';
              msg.dnisTypeDb = msg.interaction.direction == 'inbound' ? 'inbound' : 'outbound';
              break;
            case 'Text':
              msg.dnisIcon = 'message'
              msg.dnisType = msg.interaction.direction == 'inbound' ? 'IB' : 'OB'
              msg.dnisTypeDb = msg.interaction.direction == 'inbound' ? 'inbound' : 'outbound'
              break;
            case 'Note':
              msg.dnisIcon = 'edit'
              msg.dnisType = 'Note'
              msg.dnisTypeDb = 'note'
              break;
            case 'Facebook':
              break;
            case 'Voicemail':
              break;
            default:
              console.log('Not a valid document type!');
          }
          
          if (dnisObj) {
            msg.dnisLabel = dnisObj.label1;
            msg.tzadjust = dnisObj.tzadjust;
            msg.displaynum = dnisObj.displaynum;
          } else {
            let dnisInfo = await this.getDnisInfo(dnisid);
            if (dnisInfo) {
              msg.dnisLabel = dnisInfo.label1;
              msg.tzadjust = dnisInfo.tzadjust;
              msg.displaynum = dnisInfo.displaynum;
            }
          }
        
          resolve(msg);
        } catch (err) {
          console.log(err);
          reject(err);
        }
      });
    },
    getDnisInfo: async function (dnisid) {
      let endpoint = `/dnis/${dnisid}`;
      let res = await this.axios.get(endpoint, {
        responseType: 'json'
      })

      return res.data;
    },
    setMongoObject: async function (msg, isLiveCall) {
      let mongoObj = {};
      let interactionType;
      let sneakStr;
      let latestInteractionName;
      let latestInteractionAvatar;
      let latestInteractionPhonecode;
      let attachment;
      let attachmentType;
      let fileType;
      let attachmentData = {};
      let nodeIP;
      const imageTypes = ["jpg", "jpeg", "png", "gif"];
      const videoTypes = ["mp4", "avi", "m4v", "mpg", "mpeg", "mov"];
      switch(msg.interaction.type) {
        case 'Call':
          interactionType = 'call'
          sneakStr = 'no recap'
          latestInteractionName = msg.interaction.call.lename;
          if (msg.interaction.call.pc_avatar) {
            latestInteractionAvatar = `https://s3.amazonaws.com/callbox-images-external/avatars/${msg.interaction.call.phonecodeid}.jpg`
          }
          latestInteractionPhonecode = msg.interaction.call.phonecodeid;
          nodeIP = msg.interaction.call.asteriskIP;
          this.$root.$emit('scrollDisplay');
          break;
        case 'Text':
          interactionType = 'text';
          sneakStr = msg.interaction.text.body;
          latestInteractionName = msg.interaction.text.lename;
          if (msg.interaction.text.pc_avatar) {
            latestInteractionAvatar = `https://s3.amazonaws.com/callbox-images-external/avatars/${msg.interaction.text.phonecodeid}.jpg`
          }
          latestInteractionPhonecode = msg.interaction.text.phonecodeid;
          if (msg.interaction.text.attachment.length) {
            attachment = msg.interaction.text.attachment[0];  
            fileType = attachment.split('.').pop();
            if (imageTypes.includes(fileType)) {
              attachmentType = "image";
            } else if (videoTypes.includes(fileType)) {
              attachmentType = "video";
            } else {
              attachmentType = "other";
            }
          }
          if (this.currentConvo.conversationid == msg._id) {
            // this array will have attachment url plus meta data
            let attachmentDataArray = [];
            if (msg.interaction.text.attachment.length) {
              const endpoint = `https://texting.callbox.com/v2/message/signedMMS`;

              let request = {
                  MMSUrls: msg.interaction.text.attachment // now an array
                };

              const res = await this.axios.post(endpoint, request, {
                transformRequest: [
                  (data, headers) => { 
                    delete headers.common.Authorization; return JSON.stringify(data)
                  }
                ],
                headers: {
                  'Content-Type': 'application/json',
                  'Hash': this.getHash(request)
                },
              });

              let signedURls = res.data;

              for (let index = 0; index < signedURls.length; index++) {
                // in this loop,
                // we are creating an array of objects from thread.latestMessage.attachment
                // this new array, attachmentsDataArray, will have the attachment dimensions and filetype

                const attachmentUrl = signedURls[index];
                let attachmentData = {
                  file: attachmentUrl
                }
                
                var currentfileType;
                var displayedImageTypes = ["jpg","jpeg","gif","png"];
                var displayedVideoTypes = ["mp4","mov","avi","mpg","mpeg"];

                // get the file extension from signed url
                attachmentData.type = attachmentUrl.split('.').pop().split('?')[0];

                attachmentDataArray.push(attachmentData)
              }
            }
            this.$store.dispatch('displayTextIfConversationOpen', { msg: msg, attachmentData: attachmentDataArray });
            this.$root.$emit('scrollDisplay');
            if (msg.interaction.direction == 'inbound') {
              this.$root.$emit('markReadMessage', msg.interaction.text);
            }
          }
          break;
        case 'Note':
          interactionType = 'note';
          sneakStr = msg.interaction.note.text;
          latestInteractionName = msg.interaction.note.lename;
          if (msg.interaction.note.pc_avatar) {
            latestInteractionAvatar = `https://s3.amazonaws.com/callbox-images-external/avatars/${msg.interaction.note.phonecodeid}.jpg`;
          }
          latestInteractionPhonecode = msg.interaction.note.phonecodeid;
          if (this.currentConvo.conversationid == msg._id) {
            this.$store.dispatch('displayNoteIfConversationOpen', msg);
            this.$root.$emit('scrollDisplay');
          }
          break;
        case 'Facebook':
          break;
        case 'Voicemail':
          break;
        default:
          console.log('Not a valid document type!');
      }

      msg = await this.appendDnisInformation(msg.interaction[interactionType].dnisId, msg)
      let callerLabel = this.formatName(msg.customerName, msg.anis[0]._id);

      mongoObj = {
        conversation: msg,
        name: callerLabel,
        custNumber: msg.anis[0]._id,
        displayNum: msg.displaynum,
        tlInfo: msg.dnisLabel,
        type: msg.dnisType,
        icon: msg.dnisIcon,
        sneak: sneakStr,
        lskinid: msg.accountId,
        liveCall: isLiveCall,
        unaddressed: true,
        unaddressedConvo: msg.containsUnaddressed,
        selected: false,
        handledByMe: true,
        displayTime: this.formatTime(moment(msg.interaction.latestInteractionTime).format("HH:mm:ss")),
        lastCommsDate: moment(msg.interaction.latestInteractionTime).toISOString(),
        conversationid: msg._id,
        interactionid: msg.interaction[interactionType]._id,
        nodeIP: nodeIP,
        tzadjust: msg.tzadjust,
        latestInteractionName: latestInteractionName,
        latestInteractionAvatar: latestInteractionAvatar,
        latestInteractionPhonecode: latestInteractionPhonecode,
        attachment: attachment,
        attachmentType: attachmentType,
        interactionType: interactionType
      }

      return mongoObj;
    },
    checkUsage: async function () {
      let endpoint = `/users/${this.user.leuserid}/textUsage`;
      let res = await this.axios.get(endpoint, {})
      .then((response) => {
        if (response.data[0].leuserid) {
          this.showTextUsagePopup = false;
        }
      });
    }
  },
  sockets: {
    connect: function (socket) {
      console.log('CLIENT: Live Calls Socket Connected');
      this.$root.$emit('socketConnection');
    },
    conversation_update: async function (conversation) {
      if (conversation.unaddressed === true) {
        if (!conversation.interaction.call && !conversation.interaction.text) {
          return;
        }
        if (this.filterLines && conversation.interaction.type === 'Call' && !this.linesToFilter[conversation.interaction.call.dnisId]) {
          return;
        }

        let msg;
        if (conversation.interaction.type === 'Call') {
          msg = await this.setMongoObject(conversation, !conversation.interaction.call.completed);
        } else {
          msg = await this.setMongoObject(conversation, false);
        }

        if (
          msg 
          && this.aniTrack 
          && conversation.interaction 
          && conversation.interaction.call 
          && conversation.interaction.call.completed 
          && msg.latestInteractionPhonecode != this.aniTrackPhonecodeExclusion 
          && msg.custNumber == this.aniTrack
        ) {
          this.$root.$emit('campaignAniTrackFound', {
            Direction: msg.type,
            InteractionType: msg.interactionType,
            AgentName: msg.latestInteractionName,
            Datetime: msg.lastCommsDate
          })
        }
        
        if (msg) {
          Promise.all([msg]).then(result => this.$store.dispatch('displayMessage', result[0]));
        }
      }
    },
    test_message: function (message) {
      let msg = message;
      console.log('SERVER:', message);
    }
  }
}
</script>